import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PagePreloader from '../../components/PagePreloader/index';
import { getPickupData, sendPickupData, setTimeProposalMode, proposeNewTime, toggleSuccessMessage } from '../../services/pickup_slot/actions';
import { cancelSchedule } from '../../services/create_schedule/actions';
import ConfirmationPopup from '../../components/ConfirmationPopup/index';

const CancelAttendee = (props) => {
    const eventId = props.match.params.guid;
    const attendeeId = props.match.params.attendeeId
    const [cancelOpened, toggleCancelModalState] = useState(true);
    const {
        pending,
    } = useSelector(state => state.slotPickupData)

    const dispatch = useDispatch();

    useEffect(() => {
        //handleCancel();
    }, [eventId, attendeeId, dispatch]);

    const handleCancel = () => {
        cancelSchedule({ eventId, attendeeId })(dispatch);
    };
    //handleCancel();

    if (pending) {
        return <PagePreloader />
    }

    return (
        <div className='page pickup-slot'>
            <ConfirmationPopup
                title={'Confirm cancelation'}
                description={'Are you sure you want to cancel your attendance?'}
                handleConfirm={handleCancel}
                handleClose={() => toggleCancelModalState(false)}
                opened={cancelOpened}
            />

        </div>
    )
}

export default CancelAttendee;